export default __webpack_public_path__ + "static/media/teacher.2958bf60.svg";